import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Image */}
          <div className="flex-shrink-0">
            <div className="w-[220px] h-[440px] md:w-[260px] md:h-[520px] rounded-3xl overflow-hidden border-4 border-background-200">
              <img
                src={appData.image}
                alt="羞羞动漫移动端"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              移动端入口
            </h2>
            <h3 className="mt-2 text-lg md:text-xl font-semibold text-primary-600">
              {appData.title}
            </h3>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appData.desc}
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appData.features.map((feat) => (
                <span
                  key={feat}
                  className="px-4 py-2 bg-background-50 border border-background-200 rounded-full text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap"
                >
                  <i className="ri-check-line text-primary-500 mr-1.5"></i>
                  {feat}
                </span>
              ))}
            </div>

            <a
              href="#app"
              className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
            >
              <i className="ri-smartphone-line text-lg"></i>
              立即体验移动版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}